import React, { Component } from 'react';
import { node, func, objectOf, string, any, array } from 'prop-types';
import { withRouter, Route } from 'react-router';
import NProgress from 'nprogress';
import { compose } from 'redux';
import { connect } from 'react-redux';

import asyncMatchRoutes from '@blueberry/utils/asyncMatchRoutes';
import { getStore } from '@blueberry/store/configureStore';
import { defaultLanguage } from '@blueberry/constants/languages';

import { actions } from '@blueberry/redux/profile';
import { fetchSiteInfo } from '@blueberry/redux/siteInfo';

import getPrefetchers from '../../../server/utils/getPrefetchers';
import waitAll from '../../../server/utils/waitAll';

class ReduxAsyncConnect extends Component {
  static propTypes = {
    children: node.isRequired,
    fetchSiteInfo: func.isRequired,
    history: objectOf(any).isRequired,
    location: objectOf(any).isRequired,
    routes: array.isRequired,
    fetchUser: func,
    locale: string,
    token: string,
  };

  static defaultProps = {
    locale: defaultLanguage,
  };

  state = {
    previousLocation: null,
  };

  componentWillMount() {
    NProgress.configure({ trickleSpeed: 200 });
  }

  componentDidMount() {
    const { token, fetchUser, fetchSiteInfo } = this.props;
    if (token) fetchUser();
    fetchSiteInfo();
  }

  async componentWillReceiveProps(nextProps) {
    const { location, routes, locale } = this.props;
    const navigated = nextProps.location !== location;

    if (navigated) {
      // save the location so we can render the old screen
      NProgress.start();
      this.setState({ previousLocation: location });

      // load data while the old screen remains
      const { components, params } = await asyncMatchRoutes(
        routes,
        nextProps.location.pathname
      );

      const prefetchers = getPrefetchers(components, params, { locale });

      // server side preloading data.
      await getStore().runSagas(waitAll(prefetchers)).done;
      this.setState({ previousLocation: null });
      NProgress.done();
    }
  }

  render() {
    const { children, location } = this.props;
    const { previousLocation } = this.state;

    // use a controlled <Route> to trick all descendants into
    // rendering the old location
    return (
      <Route location={previousLocation || location} render={() => children} />
    );
  }
}

export default compose(
  withRouter,
  connect(null, {
    fetchUser: actions.fetchUser,
    fetchSiteInfo,
  })
)(ReduxAsyncConnect);



// WEBPACK FOOTER //
// ./app/components/ReduxAsyncConnect/ReduxAsyncConnect.jsx